import sample_1 from './generationCore.jpg';

export const generationCoreImpressions = {
    sample_1,
};
